"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsManager = void 0;
const array_1 = require("@24i/appstage-shared-perf-utils/dist/array");
class EventsManager {
    constructor() {
        this.eventListeners = {};
        this.addEventListener = (eventName, listener) => {
            if (!this.eventListeners[eventName])
                this.eventListeners[eventName] = [];
            const listeners = this.eventListeners[eventName];
            listeners.push(listener);
        };
        this.removeEventListener = (eventName, listener) => {
            const listeners = this.eventListeners[eventName];
            if (!listeners)
                return;
            const index = listeners.indexOf(listener);
            if (index !== -1)
                listeners.splice(index, 1);
        };
        this.triggerEvent = (eventName, payload) => {
            const eventListeners = this.eventListeners[eventName];
            if (!eventListeners)
                return;
            // In case listener removes itself during listening we need loop on a copy
            const listeners = (0, array_1.map)(eventListeners, (l) => l);
            (0, array_1.forEach)(listeners, (listener) => listener(payload));
        };
    }
}
exports.EventsManager = EventsManager;
